export default __webpack_public_path__ + "static/media/logo.b6d4ce1d.png";